var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F893C0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_391_462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_391_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 33C17.9 33 16.9583 32.6083 16.175 31.825C15.3917 31.0417 15 30.1 15 29V21C15 19.9 15.3917 18.9583 16.175 18.175C16.9583 17.3917 17.9 17 19 17H31C32.1 17 33.0417 17.3917 33.825 18.175C34.6083 18.9583 35 19.9 35 21V29C35 30.1 34.6083 31.0417 33.825 31.825C33.0417 32.6083 32.1 33 31 33H19ZM19 21H31C31.3667 21 31.7167 21.0417 32.05 21.125C32.3833 21.2083 32.7 21.3417 33 21.525V21C33 20.45 32.8043 19.9793 32.413 19.588C32.021 19.196 31.55 19 31 19H19C18.45 19 17.9793 19.196 17.588 19.588C17.196 19.9793 17 20.45 17 21V21.525C17.3 21.3417 17.6167 21.2083 17.95 21.125C18.2833 21.0417 18.6333 21 19 21ZM17.15 24.25L28.275 26.95C28.425 26.9833 28.575 26.9833 28.725 26.95C28.875 26.9167 29.0167 26.85 29.15 26.75L32.625 23.85C32.4417 23.6 32.2083 23.396 31.925 23.238C31.6417 23.0793 31.3333 23 31 23H19C18.5667 23 18.1877 23.1123 17.863 23.337C17.5377 23.5623 17.3 23.8667 17.15 24.25Z",
    fill: "#F893C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.8500e07374680c7064bc5669212efabc.svg";
export { ForwardRef as ReactComponent };